module.exports = __webpack_public_path__ + "static/media/icon_refrigerator.fa3a18af.svg";